import React from 'react';

const WeakAxesCallout = ({ vm }) => {
  if (!vm.weakAxes || vm.weakAxes.length === 0) {
    return null;
  }

  const styles = {
    container: {
      marginBottom: '24px',
      padding: '20px',
      background: '#fff7ed',
      border: '2px solid #fed7aa',
      borderRadius: '12px'
    },
    title: {
      fontSize: '1.125rem',
      fontWeight: '600',
      color: '#ea580c',
      marginBottom: '12px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    icon: {
      fontSize: '1.25rem'
    },
    list: {
      margin: 0,
      paddingLeft: '20px',
      color: '#7c2d12'
    },
    listItem: {
      marginBottom: '8px',
      lineHeight: '1.5'
    },
    score: {
      fontWeight: '600',
      color: '#ea580c'
    }
  };

  return (
    <div style={styles.container}>
      <h3 style={styles.title}>
        <span style={styles.icon}>🎯</span>
        Foco do Momento - Eixos que Precisam de Atenção
      </h3>
      <ul style={styles.list}>
        {vm.weakAxes.map((eixo) => (
          <li key={eixo.key} style={styles.listItem}>
            <strong>{eixo.rotulo}:</strong> <span style={styles.score}>{eixo.notaRadarFmt}/6,0</span>
            <br />
            <small>{eixo.descricao}</small>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default WeakAxesCallout;